/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    AccessTagsResponse,
    ApiMultipleResult,
    ApiResult,
    CentralSystemResponse,
    CentralSystemsResponse,
    DeviceConfigurationSchemaDto,
    DeviceGroupDto,
    InsertOrganisationRequest,
    NotificationMethodDto,
    NotificationTypeDto,
    OrganisationsResponse,
    ProvisionDeviceLookupValues,
    RolesResponse,
    UpdateOrganisationRequest,
} from "../models/index";
import {
    AccessTagsResponseFromJSON,
    AccessTagsResponseToJSON,
    ApiMultipleResultFromJSON,
    ApiMultipleResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    CentralSystemResponseFromJSON,
    CentralSystemResponseToJSON,
    CentralSystemsResponseFromJSON,
    CentralSystemsResponseToJSON,
    DeviceConfigurationSchemaDtoFromJSON,
    DeviceConfigurationSchemaDtoToJSON,
    DeviceGroupDtoFromJSON,
    DeviceGroupDtoToJSON,
    InsertOrganisationRequestFromJSON,
    InsertOrganisationRequestToJSON,
    NotificationMethodDtoFromJSON,
    NotificationMethodDtoToJSON,
    NotificationTypeDtoFromJSON,
    NotificationTypeDtoToJSON,
    OrganisationsResponseFromJSON,
    OrganisationsResponseToJSON,
    ProvisionDeviceLookupValuesFromJSON,
    ProvisionDeviceLookupValuesToJSON,
    RolesResponseFromJSON,
    RolesResponseToJSON,
    UpdateOrganisationRequestFromJSON,
    UpdateOrganisationRequestToJSON,
} from "../models/index";

export interface AssignPartnerToOrganisationRequest {
    targetOrganisationId: string;
    parentOrganisationId?: string;
    validateOnly?: boolean;
}

export interface CentralSystemInsertRequest {
    body?: CentralSystemResponse;
}

export interface CreateOrganisationRequest {
    body?: InsertOrganisationRequest;
}

export interface DeleteOrganisationRequest {
    organisationId: string;
    validateOnly?: boolean;
}

export interface GetAccessTagsRequest {
    mineOnly?: boolean;
}

export interface GetDeviceConfigurationSchemaRequest {
    deviceType?: GetDeviceConfigurationSchemaDeviceTypeEnum;
    model?: string;
}

export interface GetDeviceTypesRequest {
    mineOnly?: boolean;
}

export interface GetNotificationMethodsRequest {
    enabledOnly?: boolean;
}

export interface GetNotificationTypesRequest {
    enabledOnly?: boolean;
}

export interface GetRolesAndPermissionsRequest {
    mineOnly?: boolean;
}

export interface ServiceModelLookupRequest {
    organisationId?: string;
    deviceIdentity?: string;
}

export interface UpdateOrganisationOperationRequest {
    body?: UpdateOrganisationRequest;
}

/**
 *
 */
export class LookupHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Assign/clear an organisation\'s parent (partner).
     */
    async assignPartnerToOrganisationRaw(
        requestParameters: AssignPartnerToOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["targetOrganisationId"] == null) {
            throw new runtime.RequiredError(
                "targetOrganisationId",
                'Required parameter "targetOrganisationId" was null or undefined when calling assignPartnerToOrganisation().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["parentOrganisationId"] != null) {
            queryParameters["parentOrganisationId"] =
                requestParameters["parentOrganisationId"];
        }

        if (requestParameters["validateOnly"] != null) {
            queryParameters["validateOnly"] = requestParameters["validateOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/lookup/organisations/{targetOrganisationId}/partner`.replace(
                    `{${"targetOrganisationId"}}`,
                    encodeURIComponent(
                        String(requestParameters["targetOrganisationId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Assign/clear an organisation\'s parent (partner).
     */
    async assignPartnerToOrganisation(
        requestParameters: AssignPartnerToOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.assignPartnerToOrganisationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert a new Central System.
     */
    async centralSystemInsertRaw(
        requestParameters: CentralSystemInsertRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/central-systems`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CentralSystemResponseToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert a new Central System.
     */
    async centralSystemInsert(
        requestParameters: CentralSystemInsertRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.centralSystemInsertRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create a new Organisation.
     */
    async createOrganisationRaw(
        requestParameters: CreateOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/organisations`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: InsertOrganisationRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a new Organisation.
     */
    async createOrganisation(
        requestParameters: CreateOrganisationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createOrganisationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete an Organisation. Org must have no device groups, user accounts, or rfid tags assigned before it can be deleted.
     */
    async deleteOrganisationRaw(
        requestParameters: DeleteOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["organisationId"] == null) {
            throw new runtime.RequiredError(
                "organisationId",
                'Required parameter "organisationId" was null or undefined when calling deleteOrganisation().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        if (requestParameters["validateOnly"] != null) {
            queryParameters["validateOnly"] = requestParameters["validateOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/organisations`,
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete an Organisation. Org must have no device groups, user accounts, or rfid tags assigned before it can be deleted.
     */
    async deleteOrganisation(
        requestParameters: DeleteOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deleteOrganisationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the access tags in the system.
     * @deprecated
     */
    async getAccessTagsRaw(
        requestParameters: GetAccessTagsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<AccessTagsResponse>> {
        const queryParameters: any = {};

        if (requestParameters["mineOnly"] != null) {
            queryParameters["mineOnly"] = requestParameters["mineOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/lookup/access-tags`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            AccessTagsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Lookup the access tags in the system.
     * @deprecated
     */
    async getAccessTags(
        requestParameters: GetAccessTagsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<AccessTagsResponse> {
        const response = await this.getAccessTagsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the third party central systems in the system.
     */
    async getCentralSystemsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<CentralSystemsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/central-systems`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            CentralSystemsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Lookup the third party central systems in the system.
     */
    async getCentralSystems(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<CentralSystemsResponse> {
        const response = await this.getCentralSystemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lookup the available contractors for scheduled maintenance.
     */
    async getContractorsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/contractors`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lookup the available contractors for scheduled maintenance.
     */
    async getContractors(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<string>> {
        const response = await this.getContractorsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lookup available device configuration keys and data types for the entire system, or filtered for a DeviceType or model
     */
    async getDeviceConfigurationSchemaRaw(
        requestParameters: GetDeviceConfigurationSchemaRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceConfigurationSchemaDto>>> {
        const queryParameters: any = {};

        if (requestParameters["deviceType"] != null) {
            queryParameters["deviceType"] = requestParameters["deviceType"];
        }

        if (requestParameters["model"] != null) {
            queryParameters["model"] = requestParameters["model"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/device-configuration-schema`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceConfigurationSchemaDtoFromJSON),
        );
    }

    /**
     * Lookup available device configuration keys and data types for the entire system, or filtered for a DeviceType or model
     */
    async getDeviceConfigurationSchema(
        requestParameters: GetDeviceConfigurationSchemaRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceConfigurationSchemaDto>> {
        const response = await this.getDeviceConfigurationSchemaRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the device types in the system.
     */
    async getDeviceTypesRaw(
        requestParameters: GetDeviceTypesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters["mineOnly"] != null) {
            queryParameters["mineOnly"] = requestParameters["mineOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/lookup/device-types`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lookup the device types in the system.
     */
    async getDeviceTypes(
        requestParameters: GetDeviceTypesRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<string>> {
        const response = await this.getDeviceTypesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the notification methods in the system.
     */
    async getNotificationMethodsRaw(
        requestParameters: GetNotificationMethodsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<NotificationMethodDto>>> {
        const queryParameters: any = {};

        if (requestParameters["enabledOnly"] != null) {
            queryParameters["enabledOnly"] = requestParameters["enabledOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/lookup/notification-methods`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(NotificationMethodDtoFromJSON),
        );
    }

    /**
     * Lookup the notification methods in the system.
     */
    async getNotificationMethods(
        requestParameters: GetNotificationMethodsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<NotificationMethodDto>> {
        const response = await this.getNotificationMethodsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the notification types in the system.
     */
    async getNotificationTypesRaw(
        requestParameters: GetNotificationTypesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<NotificationTypeDto>>> {
        const queryParameters: any = {};

        if (requestParameters["enabledOnly"] != null) {
            queryParameters["enabledOnly"] = requestParameters["enabledOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/lookup/notification-types`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(NotificationTypeDtoFromJSON),
        );
    }

    /**
     * Lookup the notification types in the system.
     */
    async getNotificationTypes(
        requestParameters: GetNotificationTypesRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<NotificationTypeDto>> {
        const response = await this.getNotificationTypesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Lookup the organisations and organisation groups in the system.
     */
    async getOrganisationsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<OrganisationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/organisations`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            OrganisationsResponseFromJSON(jsonValue),
        );
    }

    /**
     * Lookup the organisations and organisation groups in the system.
     */
    async getOrganisations(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<OrganisationsResponse> {
        const response = await this.getOrganisationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lookup fields for ProvisionDevice endpoint. Includes values for DeviceType and Model
     */
    async getProvisionDeviceLookupValuesRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProvisionDeviceLookupValues>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/provision-device-values`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProvisionDeviceLookupValuesFromJSON(jsonValue),
        );
    }

    /**
     * Lookup fields for ProvisionDevice endpoint. Includes values for DeviceType and Model
     */
    async getProvisionDeviceLookupValues(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProvisionDeviceLookupValues> {
        const response =
            await this.getProvisionDeviceLookupValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lookup the roles and permissions in the system.
     */
    async getRolesAndPermissionsRaw(
        requestParameters: GetRolesAndPermissionsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<RolesResponse>> {
        const queryParameters: any = {};

        if (requestParameters["mineOnly"] != null) {
            queryParameters["mineOnly"] = requestParameters["mineOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/roles-permissions`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            RolesResponseFromJSON(jsonValue),
        );
    }

    /**
     * Lookup the roles and permissions in the system.
     */
    async getRolesAndPermissions(
        requestParameters: GetRolesAndPermissionsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<RolesResponse> {
        const response = await this.getRolesAndPermissionsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Unlike DeviceGroupsOData, which will only return device groups in your org, this method returns all ServiceModel groups that you have devices in. Optionally supply a deviceIdentity to return only the service model for that device.
     */
    async serviceModelLookupRaw(
        requestParameters: ServiceModelLookupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceGroupDto>>> {
        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/service-models`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceGroupDtoFromJSON),
        );
    }

    /**
     * Unlike DeviceGroupsOData, which will only return device groups in your org, this method returns all ServiceModel groups that you have devices in. Optionally supply a deviceIdentity to return only the service model for that device.
     */
    async serviceModelLookup(
        requestParameters: ServiceModelLookupRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceGroupDto>> {
        const response = await this.serviceModelLookupRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Edit an Organisation, an org\'s full name can be edited.
     */
    async updateOrganisationRaw(
        requestParameters: UpdateOrganisationOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/lookup/organisations/update`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateOrganisationRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Edit an Organisation, an org\'s full name can be edited.
     */
    async updateOrganisation(
        requestParameters: UpdateOrganisationOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateOrganisationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const GetDeviceConfigurationSchemaDeviceTypeEnum = {
    ChargePoint: "chargePoint",
    Illuminate: "illuminate",
    ThirdPartyPassthrough: "thirdPartyPassthrough",
    PayMate: "payMate",
    Wave: "wave",
    PowerMeter: "powerMeter",
    Core: "core",
    Barrier: "barrier",
} as const;
export type GetDeviceConfigurationSchemaDeviceTypeEnum =
    (typeof GetDeviceConfigurationSchemaDeviceTypeEnum)[keyof typeof GetDeviceConfigurationSchemaDeviceTypeEnum];
